<template>
    <div>
        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful title="View Approval :: MeritEHS"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/subcontractors`">
                            <i class="fa fa-id-badge"></i> Subcontractors
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/subcontractors/qualification/view/${sub.subcontractor_id}`">
                            {{ sub.subcontractor_name }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        Client Approval History
                    </li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-md-6 col-xl-4">
                    <div class="card mb-4">
                        <ul class="list-group list-group-flush">
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <div class="text-muted">Subcontractor</div>
                                <div>
                                    <router-link :to="`/subcontractors/view/${sub.subcontractor_id}`">
                                        {{ sub.subcontractor_name }}
                                    </router-link>
                                </div>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <div class="text-muted">Client</div>
                                <div>
                                    <router-link :to="`/clients/view/${approval.client_id}`">
                                        {{ approval.client_name }}
                                    </router-link>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="card border-success mb-3">
                <div class="card-header">
                    <label class="badge badge-success">Current Approval Results</label> -
                    Generated: <strong>{{ approval.approval_created_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}</strong> by
                    {{ approval.FirstName }} {{ approval.LastName }}
                </div>
                <div class="card-body bg-light">
                    <template v-for="result in approval.client_metrics">
                        <b-card class="mb-2 border-secondary">
                            <h6 slot="header" class="mb-0">
                                <span :class="{'badge': true, 'badge-success': result.metric_status == 'Passed', 'badge-danger': result.metric_status == 'Failed', 'badge-secondary': result.metric_status == 'N/A'}">{{ result.metric_status }}</span>
                                {{ result.metric_name }}
                            </h6>

                            <div class="row">
                                <div class="col-sm-6">
                                    <span class="mb-1 text-muted">Conditions:</span>
                                    <ul>
                                        <li v-for="cond in result.conditions">
                                            <span :class="{'text-success': cond.status == 'Passed', 'text-danger': cond.status == 'Failed', 'text-secondary': cond.status == 'N/A'}">{{ cond.status }}</span>
                                            {{ cond.attribute }} ({{ cond.attributeValue }})  {{ cond.logic }} {{ cond.value }}
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-sm-6">
                                    <span class="mb-1 text-muted">Rules:</span><br/>
                                    <small class="text-info">Minimum Required to Pass: {{ result.min_passing_rules }}</small>
                                    <ul>
                                        <li v-for="rule in result.rules">
                                            <span :class="{'text-success': rule.status == 'Passed', 'text-danger': rule.status == 'Failed', 'text-secondary': rule.status == 'N/A'}">{{ rule.status }}</span>
                                            {{ rule.attribute }} ({{ rule.attributeValue }})  {{ rule.logic }} {{ rule.value }}
                                            <span v-if="rule.immediate_fail == true" class="badge badge-danger" title="Immediate Failure Rule. If this fails, the whole metric fails.">IFR</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </b-card>
                    </template>
                </div>
            </div>
            <hr/>

            <div class="card border-secondary mb-3" v-for="history_item in data">
                <div class="card-header">
                    Generated: <strong>{{ history_item.approval_created_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}</strong> by
                    {{ history_item.FirstName }} {{ history_item.LastName }}
                </div>
                <div class="card-body bg-light">
                    <template v-for="result in history_item.client_metrics">
                        <b-card class="mb-2 border-secondary">
                            <h6 slot="header" class="mb-0">
                                <span :class="{'badge': true, 'badge-success': result.metric_status == 'Passed', 'badge-danger': result.metric_status == 'Failed', 'badge-secondary': result.metric_status == 'N/A'}">{{ result.metric_status }}</span>
                                {{ result.metric_name }}
                            </h6>

                            <div class="row">
                                <div class="col-sm-6">
                                    <span class="mb-1 text-muted">Conditions:</span>
                                    <ul>
                                        <li v-for="cond in result.conditions">
                                            <span :class="{'text-success': cond.status == 'Passed', 'text-danger': cond.status == 'Failed', 'text-secondary': cond.status == 'N/A'}">{{ cond.status }}</span>
                                            {{ cond.attribute }} ({{ cond.attributeValue }})  {{ cond.logic }} {{ cond.value }}
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-sm-6">
                                    <span class="mb-1 text-muted">Rules:</span><br/>
                                    <small class="text-info">Minimum Required to Pass: {{ result.min_passing_rules }}</small>
                                    <ul>
                                        <li v-for="rule in result.rules">
                                            <span :class="{'text-success': rule.status == 'Passed', 'text-danger': rule.status == 'Failed', 'text-secondary': rule.status == 'N/A'}">{{ rule.status }}</span>
                                            {{ rule.attribute }} ({{ rule.attributeValue }})  {{ rule.logic }} {{ rule.value }}
                                            <span v-if="rule.immediate_fail == true" class="badge badge-danger" title="Immediate Failure Rule. If this fails, the whole metric fails.">IFR</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </b-card>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {

        data: function() {
            return {
                saving: false,
                loading: true,
                errors: {},
                approval: {},
                sub: {},
                options: [],
                data: [],
                id: this.$route.params.id,
                userTimezone: this.$store.state.user.timezone,
            }
        },

        methods: {
            getApprovals()
            {
                //Get the data
                this.$http
                    .get(`client-subcontractor-approval-history/${this.id}`)
                    .then(response => {
                        //Set all the data
                        this.approval = response.data.approval;
                        this.sub = response.data.sub;
                        this.data = response.data.history;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            }
        },

        mounted() {
            this.getApprovals();
        }
    }
</script>